module.exports = __webpack_public_path__ + "assets/meest_bekeken.9b96668a.svg";